/**
 * What visitors of the public website click, sent to Google Analytics 4 (the `vue-gtag` setup in
 * main.js, measurement id `VUE_APP_GTAG`). Purpose: learn which features and questions matter to
 * trainers and studios (Ansis, 2026-10-25).
 *
 * Events carry only what was clicked — never a name, e-mail or any other identity (CLAUDE.md →
 * personal data). In GA4, register `feature`, `cta`, `location` and `question` as custom dimensions
 * (event scope) to see them in reports.
 */

export const WebsiteEvent = {
  /** A feature card on the home page was clicked → its section on /features. */
  FEATURE_CLICK: 'website_feature_click',
  /** A call-to-action button was clicked. */
  CTA_CLICK: 'website_cta_click',
  /** A FAQ question was opened. */
  FAQ_OPEN: 'website_faq_open'
}

/** Which call to action, sent as `cta`. */
export const WebsiteCta = {
  START_FREE: 'start_free',
  SEE_EXAMPLE: 'see_example',
  TALK: 'talk',
  ALL_FEATURES: 'all_features',
  ALL_QUESTIONS: 'all_questions'
}

/** Where on the site the click happened, sent as `location`. */
export const WebsiteLocation = {
  HERO: 'hero',
  HOW_IT_WORKS: 'how_it_works',
  FEATURES: 'features',
  CLOSING: 'closing',
  FEATURES_PAGE: 'features_page',
  PRICING_PAGE: 'pricing_page',
  FAQ: 'faq',
  FAQ_PAGE: 'faq_page'
}

/**
 * @param {Object} gtag the component's `this.$gtag`
 * @param {string} event one of WebsiteEvent
 * @param {Object} params only keys listed above, with values from the constants or feature keys
 */
export function trackWebsiteEvent (gtag, event, params) {
  gtag.event(event, params)
}
